import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import { translate } from 'react-i18next'

import { Roles } from '../../config'
import Loading from '../Loading'
import AppSettingsAddUser from './AppSettingsAddUser'
import AppSettingsMySettings from './AppSettingsMySettings'
import AppSettingsCompanies from './AppSettingsCompanies'

import { Tabs, Icon } from 'antd'
const TabPane = Tabs.TabPane

class AppSettings extends Component {
  render () {
    const { t, user } = this.props

    if (!user) {
      return <p>You need to be logged in to see the settings</p>
    }

    // wait for user AND his roles; wait for settings
    if (!user.projectsRoles || !user.settings) return <Loading />

    // check if user is at least Admin (or Superadmin)
    const isUserAtLeastProjectManager = user.projectsRoles
      ? _.values(user.projectsRoles).some(role => role <= Roles.PROJECT.MANAGER) || user.isSuperAdmin
      : null

    const isUserAtLeastCompanyAdmin = user.companiesRoles
      ? _.values(user.companiesRoles).some(role => role <= Roles.COMPANY.ADMIN) || user.isSuperAdmin
      : null

    return (
      <Tabs type='card'>

        <TabPane tab={<span><Icon type='user' />{t('settings.my')}</span>} key='mySettings'>
          <AppSettingsMySettings />
        </TabPane>

        {isUserAtLeastCompanyAdmin &&
          <TabPane tab={<span><Icon type='environment-o' />Companies</span>} key='companies'>
            <AppSettingsCompanies />
          </TabPane>}

        {isUserAtLeastProjectManager &&
          <TabPane tab={<span><Icon type='user-add' />{t('user.create')}</span>} key='addUser'>
            <AppSettingsAddUser />
          </TabPane>}

      </Tabs>
    )
  }
}

// =====================================
//  REDUX CONNECT
// -------------------------------------

const mapStateToProps = state => ({
  user: state.user
})

export default connect(mapStateToProps)(translate('translations')(AppSettings))



// WEBPACK FOOTER //
// ./src/components/AppSettings/index.js